// extracted by mini-css-extract-plugin
export default {"tile_card":"TileCard_tile_card__ybysk","rich_text_for_old":"TileCard_rich_text_for_old__UUpe+"};